import AutomaticallyDetectUnusualActivity from '~/components/growth_wizard/insights_onboarding/substeps/AutomaticallyDetectUnusualActivity.vue';
import InvestigateIndividualMembers from '~/components/growth_wizard/insights_onboarding/substeps/InvestigateIndividualMembers.vue';
import AutomateDetectingUnusualActivities from '~/components/growth_wizard/insights_onboarding/substeps/AutomateDetectingUnusualActivities.vue';

export const INSIGHTS_ONBOARDING_SUBSTEP_COMPONENTS = {
  automatically_detect_unusual_activity: {
    component: AutomaticallyDetectUnusualActivity,
    getProps: (vm) => ({
      members: vm.substepData.members,
      'total-members': vm.substepData.total_members,
      'total-instances': vm.substepData.total_instances,
      'total-time': vm.substepData.total_time,
    }),
  },
  investigate_individual_members: {
    component: InvestigateIndividualMembers,
    getProps: (vm) => ({
      'confidence-level': vm.substepData.confidenceLevel,
      duration: vm.substepData.duration,
      'human-duration': vm.substepData.human_duration,
      user: vm.substepData.user,
    }),
  },
  automate_detecting_unusual_activities: {
    component: AutomateDetectingUnusualActivities,
    getProps: (vm) => ({
      notifications: vm.substepData.notifications,
      organization: vm.organization,
      'substep-status': vm.updatedCurrentSubstep?.status,
      source: 'insights_onboarding_flow',
      'insights-trial-started': true,
      'insights-trial-monthly-price': 1,
    }),
  },
}
